import React, { useRef, useState } from 'react';
import { Wizard, Card, NotificationList } from 'quanta-ui';
// import ProposerDetails from './proposer-details';
import ProposerDetailsHealth from './proposer-details-health';
// import { InsuredMembers} from 'quanta-flows/modules/proposal/health';
import InsuredMembers from './insured-members';
import {PayPremium} from 'quanta-flows/modules/common/payPremium';
//import SuccessPage from './health';
import {SuccessPageHealth} from 'quanta-flows/modules/common/success';
//import {SuccessPageHealth} from './health';
//import {SuccessPage} from '../../../../common/successPage/health';
import NomineeDetails from './nominee-details';
import ReviewConfirmDetails from './review-confirm-details';
import {Loading} from 'quanta-flows/modules/layout';
import { updateBuyHealthPolicy } from 'quanta-flows/modules/proposal/health/state';
import { GET_BUY_HEALTH_POLICY_VAR_DETAILS } from '../queries';


export default function WizardPanel({
  // startStep,
  // isProposalNumberGenerated,
  // planName,
  // planCode,
  // productCode,
  // stepsDisabled,
  startStep,
  isProposalNumberGenerated,
  customerID,
  lobCode,
  lobName,
  productName,
  productCode,
  planName,
  planCode,
  proposalNumber,
  stepsDisabled,
}) {
  const [successMsg, showSuccessMsg] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const [loadingStep, setLoadingStep] = useState(false);
  const [showWizardButtonPanel, setShowWizardButtonPanel] =
    useState(null);
  const [customLoadingMessage, setCustomLoadingMessage] =
    useState(null);
  const [proceedToNextStep, setProceedToNextStep] = useState([
    false,
    false,
    false,
    false,
    false,
  ]);
  const [currentStepFunctions, setCurrentStepFunctions] = useState([
    null,
    null,
    null,
    null,
    null,
  ]);
  const proposerFormRef = useRef();
  const insuredFormRef = useRef();
  const nomineeFormRef = useRef();
  const reviewAndConfirmRef = useRef();
  const payAndPremiumRef = useRef();
  

  const steps = [
    {
      label: 'Proposer',
      proceedLabel: () => 'Proceed',
      disableStep: stepsDisabled && stepsDisabled[0] ? true : false,
      submitForm: async () => {
        if (proposerFormRef.current) {
          const res = await proposerFormRef.current.submitForm();
          // console.log(res)
          return res;
        }
        return false;
      },
      component: ({ expanded, goToStep }) =>
        expanded ? (
          loadingStep ? (
            <div className="min-h-screen">
              <Loading {...{ customMessage: customLoadingMessage }} />
            </div>
          ) : (
            <ProposerDetailsHealth
              forwardedRef={proposerFormRef}
              {...{
                goToStep,
                proceedToNextStep,
                setProceedToNextStep,
                setParentAlerts: setAlerts,
                setLoadingStep,
                setCustomLoadingMessage,
              }}
            />
          )
        ) : null,
      stepNotCompleteAlert: () => {
        setAlerts([
          {
            header: 'Unable to proceed',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>
                {
                  proposerFormRef?.current.errors?.proposerDetailsMeta?.isCRNVerified ?
                  proposerFormRef?.current.errors?.proposerDetailsMeta?.isCRNVerified :
                    proposerFormRef.current?.errors?.proposerDetailsMeta?.isConfigIMD ?
                    proposerFormRef.current?.errors?.proposerDetailsMeta?.isConfigIMD :
                  `Please fill the mandatory fields before proceeding.`
                  }
                </span>
              </div>
            ),
            type: 'warning',
            timeout: null,
            disableClose: false,
          },
        ]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    },
    {
      label: 'Members',
      proceedLabel: () => 'Proceed',
      disableStep: stepsDisabled && stepsDisabled[1] ? true : false,
      submitForm: async () => {
        if (insuredFormRef.current) {
          const res = await insuredFormRef.current.submitForm();
          return res;
        }
        return false;
      },
      onPreviousStep: () => {
        if (insuredFormRef.current) {
          let submitArr = [];
          Object.keys(insuredFormRef?.current?.values).forEach(
            (m) => {
              submitArr.push({
                relationship: m,
                ...insuredFormRef?.current?.values[m],
              });
            },
          );
          updateBuyHealthPolicy({ insuredDetails: submitArr });
        }
      },
      component: ({ expanded, goToStep }) =>
        expanded ? (
          loadingStep ? (
            <Loading customMessage={customLoadingMessage} />
          ) : (
            <InsuredMembers
              forwardedRef={insuredFormRef}
              {...{
                goToStep,
                proceedToNextStep,
                setProceedToNextStep,
                setParentAlerts: setAlerts,
              }}
            />
          )
        ) : null,
      stepNotCompleteAlert: () => {
        setAlerts([
          {
            header: 'Unable to proceed',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>
                  Please fill the mandatory fields before proceeding.
                </span>
              </div>
            ),
            type: 'warning',
            timeout: null,
            disableClose: false,
          },
        ]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    },
    {
      label: 'Additional Details',
      proceedLabel: () => 'Calculate and Proceed',
      disableStep: stepsDisabled && stepsDisabled[2] ? true : false,
      submitForm: async () => {
        if (nomineeFormRef.current) {
          const res = await nomineeFormRef.current.submitForm();
          return res;
        }
        return false;
      },
      onPreviousStep: () => {
        if (nomineeFormRef.current) {
          let submitArr = [];
          let prevInsuredArr = [];
          Object.keys(nomineeFormRef?.current?.values).forEach(
            (m) => {
              if (
                typeof nomineeFormRef?.current?.values[m] === 'object' && m?.toLowerCase() !== 'renewalmandatedetails'
              ) {
                const { prevInsuranceDetails, ...restValues } =
                  nomineeFormRef?.current?.values[m];
                submitArr.push({
                  relationship: m,
                  ...restValues,
                });
                prevInsuredArr.push(prevInsuranceDetails);
              }
            },
          );
          updateBuyHealthPolicy({
            nomineeDetails: submitArr,
            prevInsuranceDetails: prevInsuredArr,
            sameNomineeForAllInsured:
              nomineeFormRef?.current?.values
                ?.sameNomineeForAllInsured,
            isHealthDeclarationSelected:
              nomineeFormRef?.current?.values
                ?.isHealthDeclarationSelected,
            renewalMandateDetails: 
            nomineeFormRef?.current?.values
                ?.renewalMandateDetails,
          });
        }
      },
      component: ({ expanded }) =>
        expanded ? (
          loadingStep ? (
            <div className="min-h-screen">
              <Loading customMessage={customLoadingMessage} />
            </div>
          ) : (
            <NomineeDetails
              forwardedRef={nomineeFormRef}
              {...{
                proceedToNextStep,
                setProceedToNextStep,
                setParentAlerts: setAlerts,
                setCustomLoadingMessage,
                setLoadingStep,
                planName,
                planCode,
                productCode,
              }}
            />
          )
        ) : null,
      stepNotCompleteAlert: () => {
        setAlerts([
          {
            header: 'Unable to proceed',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>
                  Please fill the mandatory fields before proceeding.
                </span>
              </div>
            ),
            type: 'warning',
            timeout: null,
            disableClose: false,
          },
        ]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    },
    {
      label: 'Review & Confirm',
      proceedLabel: () =>
        isProposalNumberGenerated
          ? 'Proceed to Buy'
          : 'Create Proposal',
      disableStep: stepsDisabled && stepsDisabled[3] ? true : false,
      submitForm: async () => {
        if (reviewAndConfirmRef.current) {
          setAlerts([]);
          const res = await reviewAndConfirmRef.current.submitForm();
          return res;
        }
        return false;
      },
      onPreviousStep: () => {
        if (reviewAndConfirmRef.current) {
          updateBuyHealthPolicy({
            proposalPaymentType:
              reviewAndConfirmRef?.current?.values
                ?.proposalPaymentType,
          });
        }
      },
      component: ({ expanded, goToStep }) =>
        expanded ? (
          loadingStep ? (
            <div className="min-h-screen">
              <Loading customMessage={customLoadingMessage} />
            </div>
          ) : (
            <ReviewConfirmDetails
              forwardedRef={reviewAndConfirmRef}
              {...{
                goToStep,
                proceedToNextStep,
                setProceedToNextStep,
                currentStepFunctions,
                setCurrentStepFunctions,
                setParentAlerts: setAlerts,
                setLoadingStep,
                setCustomLoadingMessage,
                planName,
                planCode,
                productCode,
                alerts
              }}
            />
          )
        ) : null,
    },
    {
      label: 'Pay Premium',
      proceedLabel: () => 'Submit',
      disableStep: stepsDisabled && stepsDisabled[4] ? true : false,
      submitForm: async () => {
        setAlerts([]);
        if (payAndPremiumRef.current) {
          const res = await payAndPremiumRef.current.submitForm();
          return res;
        }
        return false;
      },
      onPreviousStep: () => {
        if (payAndPremiumRef.current) {
          updateBuyHealthPolicy({
            premiumDetails: payAndPremiumRef?.current?.values,
          });
        }
      },
      component: ({ expanded }) =>
        expanded ? (
          loadingStep ? (
            <div className="min-h-screen">
              <Loading customMessage={customLoadingMessage} />
            </div>
          ) : GET_BUY_HEALTH_POLICY_VAR_DETAILS ? (
            <PayPremium
              forwardedRef={payAndPremiumRef}
              {...{
                setLoadingStep,
                setCustomLoadingMessage,
                showSuccessMsg,
                setParentAlerts: setAlerts,
                setShowWizardButtonPanel,
                lobCode,
                lobName,
                productName,
                productCode,
                planName,
                planCode,
                proposalNumber,
                REACTIVE_VAR_QUERY: GET_BUY_HEALTH_POLICY_VAR_DETAILS,
                reactiveVarName: 'buyHealthPolicy',
                updateReactiveVar: updateBuyHealthPolicy,
              }}
            />
          ) : null
        ) : null,
      stepNotCompleteAlert: () => {
        setAlerts([
          {
            header: 'Unable to proceed',
            id: Date.now(),
            content: (
              <div className="flex flex-row flex-wrap space-y-2 w-full h-full">
                <span>
                  {payAndPremiumRef.current.errors?.totalPaymentAmount
                    ? payAndPremiumRef.current.errors
                        ?.totalPaymentAmount
                        : payAndPremiumRef.current.errors?.payerName
                    ?  payAndPremiumRef.current.errors?.payerName
                    : payAndPremiumRef.current.errors?.onlinePayment
                        ?.isTransactionIdVerified
                    ? payAndPremiumRef.current.errors?.onlinePayment
                        ?.isTransactionIdVerified
                        : payAndPremiumRef?.current?.errors?.cdWallet
                        ?.cdAccountCount
                    ? payAndPremiumRef?.current?.errors?.cdWallet
                        ?.cdAccountCount
                    : payAndPremiumRef.current.values
                        ?.termsAndConditions
                    ? `Please fill the mandatory fields before proceeding`
                    : 'Please fill the mandatory fields and accept terms and conditions before proceeding.'}
                </span>
              </div>
            ),
            type: 'warning',
            timeout: null,
            disableClose: false,
          },
        ]);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
    },
  ];
  return (
    <Card
      className="min-h-full"
      severity={`${successMsg ? 'SuccessPageHealth' : 'info'}`}
    >
      {successMsg ? (
        <SuccessPageHealth
          {...{
            lobCode,
            lobName,
            productName,
            productCode,
            planName,
            planCode,
            proposalNumber,
            REACTIVE_VAR_QUERY: GET_BUY_HEALTH_POLICY_VAR_DETAILS,
            reactiveVarName: 'buyHealthPolicy',
          }}
        />
      ): (
        <Wizard
          {...{
            steps,
            startStep: startStep ? startStep : 0,
            tabStyle: true,
            showButtonPanel:
              showWizardButtonPanel !== null
                ? showWizardButtonPanel
                : !loadingStep,
          }} 
        />
      )}
      <NotificationList {...{ items: alerts }} />
    </Card>
  );
};